(function() {
    'use strict';

    angular
        .module('payOffApp', ['corePRUGAGreatApp','ui.select','ngSanitize'])
        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();

